import $foreign from "./foreign.cjs";
var mapWithIndexArray = $foreign.mapWithIndexArray;
export { mapWithIndexArray };
